import { InjectionKey } from 'vue';
import { createStore, useStore as baseUseStore, Store, ActionContext } from 'vuex';

// Config
import { webhook } from '@/config/store/webhook';

export interface RootState {
  token: string;
  isLoading: boolean;
}
// define injection key
export const key: InjectionKey<Store<RootState>> = Symbol('Root');

export const store = createStore<RootState>({
  state: {
    token: '',
    isLoading: false,
  },
  mutations: {
    setIsLoading: (state: RootState, flag: boolean) => {
      state.isLoading = flag;
    },
  },
  actions: {
    setA: ({ commit }: ActionContext<RootState, RootState>, payload: number) => {
      commit('setA', payload);
    },
  },
  getters: {
    getIsLoading: (state: RootState) => state.isLoading,
  },
  modules: {
    webhook,
  },
});

// define your own `useStore` composition function
export function useStore() {
  return baseUseStore(key);
}
